export default __webpack_public_path__ + "static/media/CALENDARIO_ICONA.dc293347.svg";